
export function getMerchantLogo(images) {
    let logoPath = '';
    if (!images) { return '' }
    images.forEach((image) => {
        if (image.isFeatured) { logoPath = image.path }
    })
    return logoPath;
}